import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '分析口径',
    type: 'ARRI_AC',
}
